module.exports = __webpack_public_path__ + "static/media/semAcessos.9aaa3888.PNG";